// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.scss']
// })
// export class AppComponent {
//   title = 'ally-Helth-web-front';
// }
// src/app/app.component.ts
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { FlavourDomainService } from './service/flavour-domain.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ally-Helth-web-front';

  constructor(private titleService: Title, private FlavourDomain: FlavourDomainService) {}

  ngOnInit() {
    const config = this.FlavourDomain.domain();
    if (config) {
      this.title = config.name;
      this.titleService.setTitle(config.name);

      const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
      if (favicon) {
        favicon.href = config.favicon;
      }
    }
  }
}